export default __webpack_public_path__ + "static/versa-04a21d0dc528ddf34beea06703dc19b3.png";